import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { createFilterOptions } from '@material-ui/lab'
import { getContrastingColor } from 'react-color/lib/helpers'
import SydButton from '../../../../../commonDesign/Button'
import SydAutocomplete from '../../../../../commonDesign/SydAutocomplete'

function TagManagementBox ({
  tag,
  proposedViewsByTags,
  setProposedViewsByTags,
  viewListByTags,
  tagList,
  isTagListLoading
}) {
  const [addViewToTagValue, setAddViewToTagValue] = useState(null)

  return (
    <Box
      display='flex'
      flexDirection='column'
      gap={2}
      sx={{
        border: 'var(--border-neutral-thin)',
        borderRadius: 'var(--border-radius-md)',
        padding: 'var(--padding-md)',
        backgroundColor: '#fff'
      }}
    >
      <div
        className='rounded text-center text-bold'
        style={{
          backgroundColor: tag.color || '#E0E0E0',
          padding: '2px 6px',
          color: getContrastingColor(tag.color || '#E0E0E0'),
          display: 'inline-block',
          marginBottom: 'var(--margin-md)'
        }}
      >
        {tag.displayName || tag.name}
      </div>

      <Box
        sx={{
          width: '350px',
          height: '512px',
          overflow: 'scroll',
          borderRadius: 'var(--border-radius-sm)',
          backgroundColor: '#fff'
        }}
      >
        {
          (proposedViewsByTags?.[tag.name] ?? []).map((view, viewIndex) => (
            <div
              className='flex flex-row justify-between items-center mb-2 gap-sm radius-md p-sm bg-neutral-50'
              key={tag.id}
            >
              <span
                title={view.name}
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                  flex: 1
                }}
              >
                {view.name}
              </span>
              <SydButton
                onClick={() => {
                  const viewId = view.viewId ?? view.value
                  const newProposedViewsByTags = { ...proposedViewsByTags }
                  newProposedViewsByTags[tag.name] = (proposedViewsByTags[tag.name] || [])
                    .filter(v => (v.viewId ?? v.value) !== viewId)
                  setProposedViewsByTags(newProposedViewsByTags)
                }}
                variant='primary'
                icon='close'
                size='sm'
              >
                Remove
              </SydButton>
            </div>
          ))
        }
      </Box>

      <Box display='flex' flexDirection='row' justifyContent='space-between' gap={2} sx={{ paddingTop: 'var(--padding-lg)' }}>
        <Box sx={{ width: '250px' }}>
          <SydAutocomplete
            filterOptions={createFilterOptions()}
            options={viewListByTags
              .filter(view => !(proposedViewsByTags[tag.name] || []).some(p => (p.viewId ?? p.value) === view.viewId))
              .map(view => ({ label: view.name, value: view.viewId, name: view.name }))
              .sort((a, b) => (a.label || '').localeCompare(b.label || ''))}
            onChange={(e, val) => {
              setAddViewToTagValue(val || null)
            }}
            value={addViewToTagValue}
            placeholder='Select a View'
            disabled={!tagList?.length}
            isLoading={isTagListLoading}
            sx={{ width: '256px' }}
          />
        </Box>
        <SydButton
          onClick={() => {
            if (!addViewToTagValue) return
            const viewId = addViewToTagValue.value
            const name = addViewToTagValue.name ?? addViewToTagValue.label
            const normalized = { viewId, name }
            const newProposedViewsByTags = { ...proposedViewsByTags }
            newProposedViewsByTags[tag.name] = [...(proposedViewsByTags[tag.name] || []), normalized]
            setProposedViewsByTags(newProposedViewsByTags)
            setAddViewToTagValue(null)
          }}
          variant='primary'
          icon='add'
          size='sm'
        >
          Add
        </SydButton>
      </Box>

    </Box>
  )
}

TagManagementBox.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    color: PropTypes.string,
    viewTagId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  proposedViewsByTags: PropTypes.object.isRequired,
  setProposedViewsByTags: PropTypes.func.isRequired,
  viewListByTags: PropTypes.arrayOf(PropTypes.object).isRequired,
  tagList: PropTypes.arrayOf(PropTypes.object),
  isTagListLoading: PropTypes.bool
}

export default TagManagementBox
